import { createTheme } from '@mui/material/styles';
import { ptBR as corePtBR } from '@mui/material/locale';
import { ptBR as gridPtBR } from '@mui/x-data-grid/locales';
import { ptBR as datePickersPtBR } from '@mui/x-date-pickers/locales';

// Paleta corporativa — azul institucional. Contraste validado WCAG AA contra texto branco
// (#0d47a1 sobre #ffffff → ratio 8.59:1; #ffffff sobre #0d47a1 → ratio 8.59:1).
export const theme = createTheme(
  {
    palette: {
      mode: 'light',
      primary: {
        main: '#0d47a1',
        light: '#5472d3',
        dark: '#002171',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#00695c',
        light: '#439889',
        dark: '#003d33',
        contrastText: '#ffffff',
      },
      background: {
        default: '#f5f5f5',
        paper: '#ffffff',
      },
      text: {
        primary: '#1a1a1a',
        secondary: '#4a4a4a',
      },
      error: { main: '#c62828' },
      warning: { main: '#bf360a' }, // ratio ≥ 4.5:1 sobre background.default; valida em theme.test.ts
      success: { main: '#2e7d32' },
      info: { main: '#0277bd' },
    },
    typography: {
      fontFamily: [
        'Inter',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
      h1: { fontWeight: 600 },
      h2: { fontWeight: 600 },
      h3: { fontWeight: 600 },
      h4: { fontWeight: 600 },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
      button: { textTransform: 'none', fontWeight: 500 },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: { minHeight: 44 }, // touch target WCAG AA
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: { minWidth: 44, minHeight: 44 },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: { minHeight: 48 },
        },
      },
    },
  },
  corePtBR,
  gridPtBR,
  datePickersPtBR,
);
